import React from 'react';
import PropTypes from 'prop-types';
import {
  SET_COLLECTION,
  useAccordionListDispatchContext,
  useAccordionListStateContext,
} from 'Components/UI/TabularAccordionList/AccordionListContext';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import Button from 'Components/UI/Button';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';

function AccordionListPagination({ classes, className }) {
  const { collection } = useAccordionListStateContext();
  const dispatch = useAccordionListDispatchContext();
  const [loading, setLoading] = React.useState(false);

  const handleNextPage = () => {
    async function fetchNextCollection() {
      setLoading(true);
      const next = await collection.link('next').get();
      dispatch({ type: SET_COLLECTION, collection: next });
    }

    fetchNextCollection()
      .catch(e => displayErrorMessage(e, 'Failed to fetch the next page'))
      .finally(() => setLoading(false));
  };

  const handlePreviousPage = () => {
    async function fetchPrevCollection() {
      setLoading(true);
      const previous = await collection.link('prev').get();
      dispatch({ type: SET_COLLECTION, collection: previous });
    }

    fetchPrevCollection()
      .catch(e => displayErrorMessage(e, 'Failed to fetch the previous page'))
      .finally(() => setLoading(false));
  };

  return (
    <div className={classNames(classes.root, className)}>
      <Button
        color="primary"
        disabled={!collection?.link('prev') || loading}
        onClick={handlePreviousPage}
        startIcon={<ChevronLeftIcon />}
      >
        {'Previous'}
      </Button>
      <Button
        color="primary"
        disabled={!collection?.link('next') || loading}
        onClick={handleNextPage}
        endIcon={<ChevronRightIcon />}
      >
        {'Next'}
      </Button>
    </div>
  );
}

AccordionListPagination.defaultProps = {
  className: '',
};

AccordionListPagination.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
};

export default withStyles(theme => ({
  root: {
    height: 'auto',
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
  },
  open: {
    backgroundColor: theme.palette.facet.lightGray,
  },
}))(AccordionListPagination);
